module.exports = __webpack_public_path__ + "img/vehicle.8f3108c0.png";